import axios from 'axios';
import { apiCache } from '../utils/cache';

const BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://data.elitewash.co/' 
  : '/api';

  
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

// Add request interceptor for caching
apiClient.interceptors.request.use((config) => {
  const cacheKey = apiCache.generateKey(config.url, config.params);
  const cachedData = apiCache.get(cacheKey);
  
  if (cachedData) {
    config.adapter = () => Promise.resolve({
      data: cachedData,
      status: 200,
      statusText: 'OK',
      headers: {},
      config
    });
  }
  
  return config;
});

// Add response interceptor for caching
apiClient.interceptors.response.use((response) => {
  if (response.config.method === 'get') {
    const cacheKey = apiCache.generateKey(response.config.url, response.config.params);
    apiCache.set(cacheKey, response.data);
  }
  return response;
});

export const analyticsAPI = {
  getOrdersByStatus: (status, year = new Date().getFullYear()) => 
    apiClient.get(`/orders/filter`, { params: { status, year } }),
  getOrdersByYear: (year) => 
    apiClient.get(`/orders/filter`, { params: { year } }),
  
  getOrdersByMonth: (year, month) => 
    apiClient.get(`/orders/filter`, { params: { year, month } }),
  
  getOrdersByDateRange: (startDate, endDate, status = null, paymentMode = null) => {
    const params = { start_date: startDate, end_date: endDate };
    if (status) params.status = status;
    if (paymentMode) params.payment_mode = paymentMode;
    return apiClient.get(`/orders/filter`, { params });
  },
  
  getOrdersByPaymentMode: (paymentMode, year = new Date().getFullYear()) => 
    apiClient.get(`/orders/filter`, { params: { payment_mode: paymentMode, year } }),
  
  getDeliveredOrdersByYear: (year) => 
    apiClient.get(`/orders/filter`, { params: { status: 'Delivered', year } }),
  
  getRunningOrdersByYear: (year) => 
    apiClient.get(`/orders/filter`, { params: { status: 'running_order', year } }),
  
  getOrdersByStatusAndPayment: (status, paymentMode, year) => 
    apiClient.get(`/orders/filter`, { params: { status, payment_mode: paymentMode, year } }),
  
  getUsersByDateRange: (startDate, endDate) => 
    apiClient.get(`/users/get_users`, { params: { start_date: startDate, end_date: endDate } }),
  
  getUsersByYear: (year) => 
    apiClient.get(`/users/get_users`, { params: { year } }),
  
  getRepeatRate: () => 
    apiClient.get(`/users/repeat_rate`)
};